export const TOTAL_NET_PROCEEDS = {
  prefix: "$",
  value: 100000.04,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
